var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLink)?_c('div',{staticClass:"config-button"},[_c('button',{staticClass:"config-control-button",attrs:{"type":"button"},on:{"touchstart":_vm.goToConfig,"click":_vm.clickGoToConfig}},[_vm._v("\n        Tap\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }